var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Videos")]),_c('ul',_vm._l((_vm.videos),function(video){return _c('li',{key:video.id},[_vm._v("\n\t\t\t"+_vm._s(video.title)+"\n\t\t")])}))])}
var staticRenderFns = []

export { render, staticRenderFns }